import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import StringCompareTerminalMixin from './StringCompareTerminalMixin';
import Select2 from "shared/react_components/Select2";

const PoolParam = createReactClass({
  displayName: 'PoolParam',
  mixins: [BaseMixin, StringCompareTerminalMixin],

  render: function() {
    return (
      <form className="form-inline">
        {this.renderTerminalName()}
        {this._renderPoolParamName()}
        {this.renderRelOp()}
        {this.renderValue()}
      </form>
    );
  },

  defaultValue: function() {
    "";
  },

  poolParamValuesUrl: function() {
    return this.props.selectUrls.dynamicNumberPoolParametersUrl;
  },

  selectChangeListener: function(data) {
    this.props.node.set("pool_param_name", data.text);
  },

  _renderPoolParamName: function() {
    // initialize the text if model is already set
    var initialValue = this.props.node.get('pool_param_name');
    if (initialValue) {
      this.props.node.set("pool_param_name_label", initialValue, { silent: true });
    }

    if (this.props.editable) {
      return (
        <Select2
          uniqueNameField='pool_param_name'
          friendlyNameField='text'
          node={this.props.node}
          url={this.poolParamValuesUrl()}
          changeListener={this.selectChangeListener}
          style={{ marginRight: '5px' }}
        />
      );
    } else {
      return this._renderReadonlyValue(initialValue);
    }
  }
});

export default PoolParam;
